module.exports = __webpack_public_path__ + "img/42860491-9f15-43d4-adeb-0db2cc99174a.1e6a24b0.jpg";